import { PaginateQuery } from "core/resources/types/shared";
import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { queryClient } from "infra/packages/react-query";
import { useMutation } from "react-query";

export default function useDeletePerfil(
  filtro?: PaginateQuery,
  onSuccess?: () => void
) {
  const { isLoading, mutate, ...rest } = useMutation(
    async (id: string) => {
      const { data } = await http.delete(`/v1/perfil/${id}`);

      return data;
    },
    {
      onSuccess() {
        onSuccess?.();
        queryClient.invalidateQueries(["/v1/perfil", filtro]);
      },
      onError: (err: any) => {
        showErrorAxios(err);
      },
    }
  );

  return {
    ...rest,
    handleExcluir: mutate,
    isLoadingExcluir: isLoading,
  };
}
